import React, { useEffect, useState } from 'react';
import { callApi } from '../services/ApiServices';
import CommonLoader from '../components/common/CommonLoader';
import { ImagePath } from '../components/common/ImagePath';
import { ErrorMessage, formatCurrency, formatTimestamp } from '../utlis/function';
import CommonPagination from '../components/common/CommonPagination';
import { useSearchParams } from 'react-router-dom';
import Select,{ components }  from "react-select";


const selectStyles = {
  control: (base, state) => ({
    ...base,
    border: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    minHeight: "42px",
    paddingLeft: "4px",
    fontSize: "14px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6b7280", // tailwind gray-500
  }),
  singleValue: (base) => ({
    ...base,
    color: "#111827", // text color
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "10px",
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#f3f4f6" : "#fff",
    color: "#111827",
    cursor: "pointer",
  }),
};
 

const Transactions = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [errors, setErrors] = useState(null);
  const [dateFilter, setDateFilter] = useState({
    fromdate:"",
    todate:""
  })
  const [clubFilter, setClubFilter] = useState("")
  const limit = 10;
  const [searchParams] = useSearchParams()
  const[options, setOptions] = useState([])

  useEffect(()=>{
    if(searchParams.get("clubName") && options?.length > 0){
      const selectedOption = options.find(option => option.value === searchParams.get("clubName"));
      setClubFilter(selectedOption)
      fetchTransactions(1, limit, searchQuery, dateFilter.fromdate, dateFilter.todate, selectedOption)
    }else{
       fetchTransactions(currentPage, limit, searchQuery, dateFilter.fromdate, dateFilter.todate, clubFilter);
    }
  },[searchParams.get("clubName"), options])


  useEffect(()=>{
      getClubNames()
  },[])

    const  getClubNames = async () => {
    try {
      const response = await callApi({
        method: "get",
        url:  "admin/club-name"
      });
      const clubOptions = response.data?.map((club)=> ({
        value: club?.clubName,
        label: club?.clubName
      }))
      setOptions(clubOptions)        
    } catch (error) {
      console.error("Error fetching club Names:", error);
    }
  };

  const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}/${month}/${day}`;
};
  const fetchTransactions = async (page, limit, search, fromdate, todate, clubFilter) => {
    let ApiUrl = `transactions?page=${page}&limit=${limit}`;
     if (search) {
            ApiUrl += `&search=${search}`
          }
          if(fromdate){
            ApiUrl += `&fromDate=${formatDate(fromdate)}`   
          }
          if(todate){
            ApiUrl += `&toDate=${formatDate(todate)}`
          }
           if(clubFilter){
            ApiUrl += `&filter=${clubFilter?.value}`
          }
      if(!search){
        setLoading(true);
      } 
    try {
      const response = await callApi({
        method: "get",
        url: ApiUrl
      });
      console.log("transactions", response);

      setTransactions(response?.data);
      const totalitems = response?.pagination?.total
      const totalPages = Math.ceil(totalitems / limit);
      setTotalCount(totalPages)
      setLoading(false);
    } catch (error) {
      console.error("Error fetching transactions:", error);
      setLoading(false);
    }
  };
const handlePageChange =(e)=>{
  setCurrentPage(e)
  fetchTransactions(e, limit, searchQuery, dateFilter.fromdate, dateFilter.todate, clubFilter);
}


const CustomDropdownIndicator = (props) => {
  const { value } = props.selectProps;
  // if value selected → hide arrow 
  if (value) return null;

  // else show default arrow
  return <components.DropdownIndicator {...props} />;
};
const IndicatorSeparator = () => null;

  return (
    <div className="space-y-6">
      {/* Search Bar */}
      {loading && <CommonLoader fullScreen />}
      <div className="flex flex-col md:flex-row md:items-end gap-4">
        <div className="flex flex-col max-w-[314px] w-full">
          <label className="text-sm text-gray-500 mx-2 opacity-0 select-none">
            Search
          </label>
          <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 w-full">
            <div className="relative">
              <svg
                className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-textcolor"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <input
                type="search"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                  fetchTransactions(
                    1,
                    limit,
                    e.target.value,
                    dateFilter.fromdate,
                    dateFilter.todate,
                    clubFilter,
                  );
                }}
                onKeyDown={(e) => {
                  if (e.key === " " && searchQuery?.length === 0) {
                    e.preventDefault();
                  }
                }}
                className="w-full pl-10 pr-4 py-2.5 border-0 rounded-lg focus:outline-none text-base text-textcolor placeholder:text-textcolor"
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col max-w-[220px] w-full">
          <label className="text-sm text-gray-500 mx-2 items-center">
            Select club
          </label>
          <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 w-full">
            <Select
              options={options}
              value={clubFilter}
              onChange={(selectedOption) => {
                setClubFilter(selectedOption);
                setCurrentPage(1);
                fetchTransactions(
                  1,
                  limit,
                  searchQuery,
                  dateFilter.fromdate,
                  dateFilter.todate,
                  selectedOption,
                );
              }}
              styles={selectStyles}
              placeholder="Select option"
              classNamePrefix="react-select"
              isClearable
              isSearchable={false}
               components={{ DropdownIndicator: CustomDropdownIndicator,IndicatorSeparator }}
            />
          </div>
        </div>

        {/* From Date */}
        <div className="flex flex-col max-w-[220px] w-full">
          <label className="text-sm text-gray-500 mx-2 items-center">
            From Date
          </label>
          <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 w-full">
            <input
              type="date"
              value={dateFilter.fromdate}
              onChange={(e) => {
                setDateFilter((prev) => ({
                  ...prev,
                  fromdate: e.target.value,
                }));
                setCurrentPage(1);

                if (dateFilter.todate && e.target.value > dateFilter.todate) {
                  setErrors("To date should be greater than from date");
                  return;
                }
                // fetchTransactions(
                //   1,
                //   limit,
                //   searchQuery,
                //   e.target.value,
                //   dateFilter.todate,
                // );
              }}
              className="w-full px-3 py-2.5 pr-4 border-0 rounded-lg text-sm focus:outline-none"
            />
          </div>
        </div>

        {/* To Date */}
        <div className="flex flex-col max-w-[220px] w-full relative">
          <label className="text-sm text-gray-500 mx-2">To Date</label>
          <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-1 w-full">
            <input
              type="date"
              value={dateFilter.todate}
              onChange={(e) => {
                setDateFilter((prev) => ({ ...prev, todate: e.target.value }));
                if (dateFilter.fromdate > e.target.value) {
                  setErrors("To date should be greater than from date");
                  return;
                }
                setCurrentPage(1);
                // fetchTransactions(
                //   1,
                //   limit,
                //   searchQuery,
                //   dateFilter.fromdate,
                //   e.target.value,
                // );
                setErrors(null);
              }}
              className="w-full px-3 py-2.5 border-0 rounded-lg text-sm focus:outline-none"
            />
          </div>
          <p className="absolute top-full mb-2 ">
            <ErrorMessage message={errors} onClose={() => setErrors(null)} />
          </p>
        </div>

        <button
          className="w-full sm:w-auto flex items-center justify-center cursor-pointer gap-2 bg-primary hover:bg-hover text-white font-medium text-base px-6 py-3 rounded-lg transition-colors"
          onClick={() => {
            if (dateFilter.fromdate || dateFilter.todate) {
              fetchTransactions(
                1,
                limit,
                searchQuery,
                dateFilter.fromdate,
                dateFilter.todate,
                clubFilter,
              );
            }
          }}
        >
          Apply
        </button>
        {(dateFilter.fromdate ||
          dateFilter.todate ||
          searchQuery ||
          clubFilter) && (
          <button
            className="w-full sm:w-auto flex items-center cursor-pointer justify-center gap-2 bg-primary hover:bg-hover text-white font-medium text-base px-6 py-3 rounded-lg transition-colors"
            onClick={() => {
              setDateFilter({
                fromdate: "",
                todate: "",
              });
              setErrors(null);
              setClubFilter("");
              setSearchQuery("");
              fetchTransactions(1, limit, "", "", "", "");
            }}
          >
            Clear
          </button>
        )}
      </div>
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] overflow-hidden mt-[42px]">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#fafafa] border-b border-gray-200 ">
              <tr>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Club name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  User name
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Date
                </th>
                {/* <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Service fee
                </th> */}
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Payment method
                </th>
                <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Amount
                </th>
                 <th className="px-6 py-3 text-left text-base font-medium text-black">
                  Purpose
                </th> 
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {transactions?.length > 0 ? (
                transactions?.map((transaction, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="px-6 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                          <img
                            src={transaction?.logo}
                            alt={transaction.clubName}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="text-sm font-medium text-textcolor">
                          {transaction.clubName || "-"}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-3">
                      {transaction?.userName || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {formatTimestamp(transaction?.createdAt) || "-"}
                    </td>

                    {/* <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {transaction?.transaction_us_email || "-"}
                    </td> */}
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {transaction?.card
                        ? `${transaction?.card.charAt(0).toUpperCase() + transaction?.card.slice(1).toLowerCase()}****${transaction?.cardLast4}`
                        : "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {transaction?.amount ? `$${transaction?.amount}` : "-"}
                    </td>
                    <td className='px-6 py-3 text-sm font-normal text-textcolor'>
                      {transaction?.paymentStatus ? transaction?.paymentStatus.charAt(0).toUpperCase()+ transaction?.paymentStatus.slice(1).toLowerCase() : "-"}</td>
                    {/* <td className="px-6 py-3 text-sm font-normal text-textcolor">
                      {transaction?.transactionStatus ? transaction?.transactionStatus.charAt(0).toUpperCase() + transaction?.transactionStatus.slice(1).toLowerCase() : "-"}
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="px-6 py-3 text-sm font-normal text-textcolor"
                  >
                    <div className="flex justify-center items-center mt-5">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2 text-center">No data found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={(e) => handlePageChange(e)}
      />
    </div>
  );
};

export default Transactions;
